import React from 'react'

const Softskills = () => {
  return (
    <div className="sklls__content">
        <h3 className="skills__titlle">OS / SoftSkills</h3>

        <div className="skills__box">
            <div className="skills__group">
                <div className="skills__data">
                <i class='bx bx-check-circle'></i>

                <div>
                    <h3 className="skills__name">Windows</h3>
                    <span className="skills__level">11 Beta</span>
                </div>

                </div>

                <div className="skills__data">
                <i class='bx bx-check-circle'></i>

                <div>
                    <h3 className="skills__name">Mac OS</h3>
                    <span className="skills__level">Sonoma </span>
                </div>

                </div>

                <div className="skills__data">
                <i class='bx bx-check-circle'></i>

                <div>
                    <h3 className="skills__name">Linux</h3>
                    <span className="skills__level">Ubuntu/Kali</span>
                </div>

                </div>
            </div>

            <div className="skills__group">
                <div className="skills__data">
                <i class='bx bx-check-circle'></i>

                <div>
                    <h3 className="skills__name">Problem</h3>
                    <span className="skills__level">Solving</span>
                </div>

                </div>

                <div className="skills__data">
                <i class='bx bx-check-circle'></i>

                <div>
                    <h3 className="skills__name">Creativity </h3>
                    <span className="skills__level">UI/UX</span>
                </div>

                </div>

                <div className="skills__data">
                <i class='bx bx-check-circle'></i>

                <div>
                    <h3 className="skills__name">Teamwork</h3>
                    <span className="skills__level">Collabration</span>
                </div>

                </div>
            </div>
        </div>
    </div>
  )
}

export default Softskills
